import AddNewPatientButton from './AddNewPatientButton'

export default AddNewPatientButton



// WEBPACK FOOTER //
// ./src/legacy/components/AddNewPatientButton/index.js